import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Landmark, Menu, X, UserRound } from "lucide-react";
import { useJamaah } from "@/context/JamaahContext";
import { fileUrl } from "@/lib/api";

const NAV = [
  { id: "jadwal", label: "Jadwal Sholat", to: "/jadwal-sholat" },
  { id: "kegiatan", label: "Kegiatan", to: "/kegiatan" },
  { id: "pengumuman", label: "Pengumuman", to: "/pengumuman" },
  { id: "keuangan", label: "Keuangan", to: "/keuangan" },
  { id: "donasi", label: "Donasi", to: "/donasi" },
  { id: "pengurus", label: "Pengurus", to: "/pengurus" },
  { id: "kontak", label: "Kontak", to: "/kontak" },
];

export const Header = ({ profile }) => {
  const [open, setOpen] = useState(false);
  const { jamaah } = useJamaah();
  const { pathname } = useLocation();
  const logo = profile?.logo_path ? fileUrl(profile.logo_path) : null;

  const NavItem = ({ n, className, testId }) => (
    <Link to={n.to} onClick={() => setOpen(false)} className={`${className} ${pathname.startsWith(n.to) ? "text-emerald-900 font-semibold" : ""}`} data-testid={testId}>{n.label}</Link>
  );

  return (
    <header className="sticky top-0 z-50 glass border-b border-emerald-900/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3" data-testid="public-nav-home">
          {logo ? (
            <img src={logo} alt="Logo Masjid" className="h-9 w-9 rounded-xl object-contain bg-white" data-testid="public-nav-logo" />
          ) : (
            <div className="h-9 w-9 rounded-xl emerald-bg flex items-center justify-center text-[#d4af37]" data-testid="public-nav-logo-default">
              <Landmark size={18} />
            </div>
          )}
          <div className="leading-tight">
            <p className="font-bold text-emerald-950 text-sm sm:text-base">{profile?.name || "Masjid Al-Iman"}</p>
            <p className="text-[11px] text-emerald-700 hidden sm:block">Banjarwaru · Kawali · Ciamis</p>
          </div>
        </Link>
        <nav className="hidden lg:flex items-center gap-7">
          {NAV.map((n) => (
            <NavItem key={n.id} n={n} className="text-sm font-medium text-slate-700 hover:text-emerald-800 transition-colors" testId={`public-nav-${n.id}`} />
          ))}
        </nav>
        <div className="flex items-center gap-2">
          <Link
            to={jamaah ? "/portal" : "/bergabung"}
            className="inline-flex items-center gap-2 rounded-full emerald-bg text-white text-sm font-semibold px-4 py-2 hover:bg-[#145c48] transition-colors"
            data-testid="public-nav-bergabung"
          >
            <UserRound size={14} /> {jamaah ? "Portal Saya" : "Bergabung"}
          </Link>
          <button className="lg:hidden p-2 text-emerald-900" onClick={() => setOpen(!open)} data-testid="public-nav-toggle" aria-label="Menu">
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>
      {open && (
        <nav className="lg:hidden border-t border-emerald-900/10 bg-white/95 px-4 py-3 flex flex-col gap-2" data-testid="public-nav-mobile">
          {NAV.map((n) => (
            <NavItem key={n.id} n={n} className="py-2 text-sm font-medium text-slate-700" testId={`public-nav-mobile-${n.id}`} />
          ))}
        </nav>
      )}
    </header>
  );
};
